<template>
  <div class="titleFilter">
    <h1>Disponíveis</h1>
  </div>
  <div class="container_filter">
    <div
      class="filter"
      @click="myFilterGalpaoFilial"
      :class="{ showFilter: showFilter_Galpao_Filial }"
    >
      <p>Galpão</p>
    </div>
    <div
      class="filter"
      @click="myFilterFilial"
      :class="{ showFilter: showFilter_Filial }"
    >
      <p>Filial</p>
    </div>
    <div
      class="filter"
      @click="myFilterCd"
      :class="{ showFilter: showFilter_Cd }"
    >
      <p>CD</p>
    </div>
    <div
      class="filter"
      @click="myFilterMatriz"
      :class="{ showFilter: showFilter_Matriz }"
    >
      <p>Matriz</p>
    </div>
  </div>
  <div class="total">
    <h3>Total:</h3>
    <h1>{{ valorTotal }}</h1>
  </div>
</template>
<script>
export default {
  name: "FilterDisp",
  emits: ["trocarValor", "matriz", "filial", "cd", "jaguarao"],
  props: {
    valorTotal: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // embalagensDisponiveis() {
    //   return this.$store.getters.listarEmbalagem
    //     // .filter((emb) => emb.status == 0)
    //     // .filter((emb) => emb.origem == this.total).length;
    //   // || emb.origem == "Filial" || emb.origem == "CD" || emb.origem == "Jaguarão"
    // },
  },
  data: () => {
    return {
      showFilter_Galpao_Filial: true,
      showFilter_Matriz: false,
      showFilter_Filial: false,
      showFilter_Cd: false,
      showFilter_Jaguarao: false,
      total: "Filial",
    };
  },
  methods: {
    myFilterGalpaoFilial() {
      this.showFilter_Galpao_Filial = true;
      this.showFilter_Matriz = false;
      this.showFilter_Filial = false;
      this.showFilter_Cd = false;
      this.total = "Galpão";
      this.$emit("unity", "Galpão");
    },
    myFilterMatriz() {
      this.showFilter_Galpao_Filial = false;
      this.showFilter_Matriz = true;
      this.showFilter_Filial = false;
      this.showFilter_Cd = false;
      this.total = "Matriz";
      this.$emit("unity", "Matriz");
    },
    myFilterFilial() {
      this.showFilter_Galpao_Filial = false;
      this.showFilter_Matriz = false;
      this.showFilter_Filial = true;
      this.showFilter_Cd = false;
      this.total = "Filial";
      this.$emit("unity", "Filial");
    },
    myFilterCd() {
      this.showFilter_Galpao_Filial = false;
      this.showFilter_Matriz = false;
      this.showFilter_Filial = false;
      this.showFilter_Cd = true;
      this.total = "CD";
      this.$emit("unity", "CD");
    },
  },
};
</script>
<style scoped>
.titleFilter {
  border-bottom: 2px solid rgba(0, 0, 0, 0.116);
  padding: 1rem 0;
}
.container_filter {
  display: flex;
  padding: 1rem 0;
}
.container_filter p {
  font-weight: 600;
}
.filter {
  background: var(--colorFilterButton);
  margin-right: 0.5rem;
  padding: 0.3rem;
  width: 5rem;
  text-align: center;
  border-radius: 1rem;
  cursor: pointer;
}
.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0;
}
.total h3 {
  color: var(--colorText-secondary);
  font-weight: 200;
}
.total h1 {
  color: var(--colorPrimary);
  font-weight: 200;
}
.showFilter {
  background: var(--colorPrimary);
  color: var(--white);
}
.showFilterF {
  background: var(--unityFilial);
  color: var(--white);
}
.showFilterC {
  background: var(--unityCd);
  color: var(--white);
}
.showFilterJ {
  background: var(--unityJaguarao);
  color: var(--white);
}
</style>
